import { render, staticRenderFns } from "./AddIssue.vue?vue&type=template&id=3bb93424&scoped=true&"
import script from "./AddIssue.vue?vue&type=script&lang=js&"
export * from "./AddIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb93424",
  null
  
)

export default component.exports